module.exports = __webpack_public_path__ + "static/media/catalogueImg8.f75bf52c.png";